import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IRPStore} from "../../../app/rp_reducer";
import {SchemaArticleAuthorDetail} from "../../schemas/SchemaArticleAuthorDetail";
import {AuthorArticlesListing} from "./AuthorArticlesListing";
import {AuthorDescription} from "./AuthorDescription";

export const ArticleAuthorsDetailView = () => {
    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author?.name);
    const description = useSelector((state: IRPStore) => state.article.authorDetail.author?.description);
    const locationPathname = useLocation().pathname;
    const authorImageUrl = useSelector((state: IRPStore) => state.article.authorDetail.author?.image?.a_img_360x360);

    return (
        <Container>
            <SchemaArticleAuthorDetail name={authorName} description={description} pathname={locationPathname} authorImageUrl={authorImageUrl} />

            <Breadcrumbs
                className={css({mb: 8})}
                homePageUrl={rpAppLink.base()}
                items={[{name: "Wiadomości", url: rpAppLink.article.list()}, {name: "Autorzy", url: rpAppLink.article.author.list()}, {name: authorName ?? ""}]}
            />

            <AuthorDescription className={css({mb: 3, md: {mb: 8}})} css={[mb(3), onDesktop(mb(8))]} />
            <AuthorArticlesListing />
        </Container>
    );
};
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IRPStore} from "../../../app/rp_reducer";
import {SchemaArticleAuthorDetail} from "../../schemas/SchemaArticleAuthorDetail";
import {AuthorArticlesListing} from "./AuthorArticlesListing";
import {AuthorDescription} from "./AuthorDescription";

export const ArticleAuthorsDetailView = () => {
    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author?.name);
    const description = useSelector((state: IRPStore) => state.article.authorDetail.author?.description);
    const locationPathname = useLocation().pathname;
    const authorImageUrl = useSelector((state: IRPStore) => state.article.authorDetail.author?.image?.a_img_360x360);

    return (
        <Container>
            <SchemaArticleAuthorDetail name={authorName} description={description} pathname={locationPathname} authorImageUrl={authorImageUrl} />

            <Breadcrumbs
                className={css({mb: 8})}
                homePageUrl={rpAppLink.base()}
                items={[{name: "Wiadomości", url: rpAppLink.article.list()}, {name: "Autorzy", url: rpAppLink.article.author.list()}, {name: authorName ?? ""}]}
            />

            <AuthorDescription className={css({mb: 3, md: {mb: 8}})} css={[mb(3), onDesktop(mb(8))]} />
            <AuthorArticlesListing />
        </Container>
    );
};
